import React, { useEffect } from "react";
import { BiX } from "react-icons/bi";
import { useDispatch } from "react-redux";
import { useToasts } from "react-toast-notifications";
import ImageNotFound from "../../Assets/default-img.jpg";
import Logo from "../../Assets/Logo";
import { url } from "../../Constants";
import { setKeranjang } from "../../redux/actions/prepareActions";
import { decrypt, encrypt } from "../../utils/enkripsi";
import formatterMoney from "../../utils/formatMoney";
import { showLog } from "../../utils/log";
import "./ModalBayar.css";

export default function ModalPaket({
  showModalPaket,
  setShowModalPaket,
  onClickTambahPesanan,
  dataOrder,
}) {
  const dispatch = useDispatch();
  const { addToast } = useToasts();
  const [quantity, setQuantity] = React.useState(1);
  const [quantity2, setQuantity2] = React.useState(0);
  const [note, setNote] = React.useState("");
  const [products, setProducts] = React.useState("");
  const [products2, setProducts2] = React.useState("");
  let pesanan = localStorage.getItem("pesanan");
  const handleOnChange = (e) => {
    setProducts(e.target.value);
  };
  const handle = (e) => {
    setProducts2(e.target.value);
  };
  pesanan = pesanan == null ? [] : decrypt(JSON.parse(pesanan));

  useEffect(() => {
    showLog("ModalPaketPromo Masuk useEffect 1");
    if (showModalPaket) {
      let pesanan1 = decrypt(JSON.parse(localStorage.getItem("pesanan")));
      setNote("");
      if (pesanan1) {
        if (pesanan1.length !== 0) {
          let number = 1;
          let price = 0;
          for (const x of pesanan1) {
            if (dataOrder["name"] == x["name"]) {
              number = x["item"];
              price = x["item"];
              setNote(x["note"]);
            }
          }
          setQuantity(number);
          setQuantity2(price);
        }
      }
    }
  }, [showModalPaket]);

  function imageExists(url, callback) {
    showLog("ModalPaketPromo Masuk imageExists");
    var img = new Image();
    img.onload = function () {
      callback(true);
    };
    img.onerror = function () {
      callback(false);
    };
    img.src = url;
  }

  var imageUrl = url + dataOrder["picpath1"];
  imageExists(imageUrl, function (exists) {
    if (exists == true) {
      dataOrder["show_img"] = true;
    } else {
      dataOrder["show_img"] = false;
    }
  });
  let category = [];
  for (let data in dataOrder.category) {
    category.push(dataOrder.category[data].category_name);
  }

  return (
    <div className={showModalPaket ? "modal-menu active" : "modal-menu"}>
      <div
        onClick={() => setShowModalPaket(false)}
        style={{
          margin: "10px 0px 0 10px",
          position: "fixed",
          borderRadius: 40,
          height: 40,
          width: 40,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "rgba(0, 0, 0, 0.3)",
        }}
      >
        <BiX size={30} color="#fff" />
      </div>
      {dataOrder["show_img"] && (
        <>
          {dataOrder["picpath1_thumb"] !== "-" &&
          dataOrder["picpath1_thumb"] ? (
            <img
              style={{
                // height: '40%',
                width: "100%",
                borderTopLeftRadius: 20,
                borderTopRightRadius: 20,
                marginBottom: 10,
              }}
              src={url + dataOrder["picpath1_thumb"]}
            />
          ) : (
            <img
              style={{
                // height: '40%',
                width: "100%",
                borderTopLeftRadius: 20,
                borderTopRightRadius: 20,
                marginBottom: 10,
              }}
              src={ImageNotFound}
            />
          )}
        </>
      )}
      {!dataOrder["show_img"] && (
        <div
          style={{
            width: "100%",
            borderTopLeftRadius: 20,
            borderTopRightRadius: 20,
            marginBottom: 10,
            height: "40%",
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
          }}
        >
          <Logo height="50" width="200" />
        </div>
      )}
      <div style={{ width: "100%" }}>
        <div style={{ margin: 20 }}>
          <div className="fonts700" style={{ fontSize: 16, paddingTop: 5 }}>
            {dataOrder["name"]}
          </div>
          <div style={{ fontSize: 14, paddingTop: 5, color: "#BFBFBF" }}>
            {dataOrder["description"]}
          </div>
          {dataOrder?.category?.map(
            (items) =>
              items["category_name"] == category[0] && (
                <div
                  style={{ fontSize: 16, paddingTop: 20 }}
                  value={items["category_name"]}
                >
                  <span className="fonts700">{items["category_name"]}</span>
                  {items.detail.map((data) => (
                    <div
                      className="row"
                      style={{ paddingTop: 5, fontSize: 14 }}
                    >
                      <div className="col-sm-12">
                        <form>
                          <div className="radio">
                            <label>
                              <input
                                type="radio"
                                value={data.product_name}
                                onChange={handle}
                                checked={products2 == data.product_name}
                              />
                              <span style={{ paddingLeft: 10 }}>
                                {data.product_name}
                              </span>
                            </label>
                          </div>
                        </form>
                      </div>
                    </div>
                  ))}
                </div>
              )
          )}
          {dataOrder?.category?.map(
            (items) =>
              items["category_name"] == category[1] && (
                <div
                  style={{ fontSize: 16, paddingTop: 5 }}
                  value={items["category_name"]}
                >
                  <span className="fonts700">{items["category_name"]}</span>
                  {items.detail.map((data) => (
                    <div
                      className="row"
                      style={{ paddingTop: 5, fontSize: 14 }}
                    >
                      <div className="col-sm-12">
                        <form>
                          <div className="radio">
                            <label>
                              <input
                                type="radio"
                                value={data.product_name}
                                onChange={handleOnChange}
                                checked={products == data.product_name}
                              />
                              <span style={{ paddingLeft: 10 }}>
                                {data.qty} {data.product_name}
                              </span>
                            </label>
                          </div>
                        </form>
                      </div>
                    </div>
                  ))}
                </div>
              )
          )}
          <div style={{ display: "flex", paddingTop: 100 }}>
            <div
              style={{
                display: "flex",
                width: "40%",
                backgroundColor: "#fff",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div
                className="fonts700"
                style={{ color: "#162A48", paddingTop: 2 }}
              >
                {"Rp" + formatterMoney(dataOrder["harga"])}
              </div>
            </div>
            <div
              style={{
                width: "140%",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <button
                onClick={() => {
                  if (products === "" || products2 === "") {
                    addToast("Tolong tambahkan Pesanan", {
                      appearance: "success",
                      autoDismiss: true,
                      autoDismissTimeout: 1500,
                    });
                  } else {
                    let name = [];
                    for (const xi of pesanan) {
                      if (xi["name"] == dataOrder["name"]) {
                        name.push(xi["name"]);
                      }
                    }
                    if (products == products && products2 == products2) {
                      name.push(products);
                      name.push(products2);
                    }
                    if (name.includes(dataOrder["name"])) {
                      for (const resultOrder of pesanan) {
                        if (resultOrder["name"] == dataOrder["name"]) {
                          resultOrder["item"] = quantity;
                          resultOrder["total"] = dataOrder["harga"] * quantity;
                        }
                      }
                    } else {
                      pesanan.push(
                        Object.assign(dataOrder, {
                          product: products,
                          product2: products2,
                          item: quantity,
                          total: dataOrder["harga"] * quantity,
                          note: note,
                        })
                      );
                    }
                    const resultPesanan = pesanan.filter(
                      (items) => items["item"].toString() !== "0"
                    );
                    localStorage.setItem(
                      "pesanan",
                      JSON.stringify(encrypt(resultPesanan))
                    );
                    setShowModalPaket(false);
                    dispatch(setKeranjang());
                    if (quantity > quantity2) {
                      onClickTambahPesanan();
                    }
                  }
                }}
                style={{
                  padding: "7px 0 7px 0",
                  borderRadius: 5,
                  backgroundColor: "#552CB7",
                  width: "100%",
                  border: "none",
                  marginLeft: "30px",
                }}
              >
                <span style={{ color: "#fff" }} className="fonts500">
                  Tambah Pesanan
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
